import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { MapTypesToDisplayAs } from '../utils/enum';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  values: string[];
  options: string[];
  label: string;
  allowChips: boolean;
  handleStatusChange: (event: SelectChangeEvent<string[]>) => void;
  handleDeleteChip: (deletedChip: string) => void;
}

const MultiSelectDropdownToTypes = ({
  label,
  values,
  options,
  allowChips,
  handleStatusChange,
  handleDeleteChip
}: Props): JSX.Element => {
  return (
    <FormControl
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '8px',
        borderRadius: '8px',
        maxWidth: '100%',
        '@media (min-width: 507px)': {
          maxWidth: '100%',
          alignItems: 'flex-start'
        },
        '@media (min-width:1032px)': {
          maxWidth: '182px',
          alignItems: 'flex-end'
        },
        '@media (min-width:1184px)': {
          maxWidth: '182px',
          alignItems: 'flex-end'
        }
      }}
    >
      <Select
        multiple
        displayEmpty
        value={values}
        onChange={handleStatusChange}
        renderValue={() => label}
        sx={{
          borderRadius: '8px',
          maxHeight: '48px',
          width: '100%',
          color: '#5F6368'
        }}
        fullWidth
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={values.includes(option)} />
            {option}
          </MenuItem>
        ))}
      </Select>
      {allowChips ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            gap: '8px',
            '@media (max-width: 472px) and (max-height: 997px)': {
              flexWrap: 'wrap',
              justifyContent: 'center'
            },
            '@media (min-width: 473px) and (max-height: 997px)': {
              flexDirection: 'row'
            }
          }}
        >
          {values.map((option, index) => (
            <Chip
              key={`${option}-${index}`}
              label={MapTypesToDisplayAs(option)}
              onDelete={() => handleDeleteChip(option)}
              sx={{
                backgroundColor: '#C9E6FF',
                height: '18px',
                fontSize: '10px'
              }}
              deleteIcon={<CloseIcon style={{ fontSize: 'small' }} />}
            />
          ))}
        </Box>
      ) : null}
    </FormControl>
  );
};

export default MultiSelectDropdownToTypes;
